import type { ExpiringState } from "@/types/waitlist";

export const WAITLIST_FLOATER_EVENT_NAME = "vts-premium-waitlist-change";

const WAITLIST_JOINED_KEY = "vts-premium-waitlist-joined";
const WAITLIST_FLOATER_DISMISSED_KEY = "vts-premium-waitlist-floater-dismissed";
const WAITLIST_DISMISS_DAYS = 7;

function isBrowser(): boolean {
  return (
    typeof window !== "undefined" && typeof window.localStorage !== "undefined"
  );
}

function readExpiringState(key: string): boolean {
  if (!isBrowser()) return false;

  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) return false;

    const stored = JSON.parse(raw) as Partial<ExpiringState>;
    if (!stored.expiresAt || stored.expiresAt <= Date.now()) {
      window.localStorage.removeItem(key);
      return false;
    }

    return true;
  } catch {
    return false;
  }
}

function writeExpiringState(key: string, days: number): void {
  if (!isBrowser()) return;

  window.localStorage.setItem(
    key,
    JSON.stringify({
      expiresAt: Date.now() + days * 24 * 60 * 60 * 1000,
    }),
  );
  window.dispatchEvent(new Event(WAITLIST_FLOATER_EVENT_NAME));
}

export function isPremiumWaitlistJoined(): boolean {
  return readExpiringState(WAITLIST_JOINED_KEY);
}

export function markPremiumWaitlistJoined(): void {
  writeExpiringState(WAITLIST_JOINED_KEY, 365);
}

export function isWaitlistFloaterDismissed(): boolean {
  return readExpiringState(WAITLIST_FLOATER_DISMISSED_KEY);
}

export function dismissWaitlistFloater(): void {
  writeExpiringState(WAITLIST_FLOATER_DISMISSED_KEY, WAITLIST_DISMISS_DAYS);
}

// Fired when a free user tries to use a premium-gated feature.
export const PREMIUM_GATE_EVENT_NAME = "vts-premium-gate";

export function triggerPremiumGate(): void {
  if (!isBrowser()) return;
  window.dispatchEvent(new Event(PREMIUM_GATE_EVENT_NAME));
}
